import React from 'react'
import { navigate } from 'gatsby-link'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers'
import * as yup from 'yup'

function encode(data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&')
}

const schema = yup.object().shape({
  name: yup.string().required('Please enter your name'),
  email: yup
    .string()
    .email('Please enter a valid email')
    .required('Please enter your email'),
  subject: yup.string().required('Please enter a subject'),
  message: yup.string().required('Please enter a message'),
})

const ContactForm = () => {
  const { register, handleSubmit, errors } = useForm({
    resolver: yupResolver(schema),
  })

  const onSubmit = data => {
    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: encode({
        'form-name': 'contact',
        ...data,
      }),
    })
      .then(() => navigate('/contact-thanks'))
      .catch(error => alert(error))
  }

  return (
    <div>
      <form
        name="contact"
        method="post"
        action="/contact-thanks"
        data-netlify="true"
        netlify-honeypot="bot-field"
        onSubmit={handleSubmit(onSubmit)}
      >
        {/* The `form-name` hidden field is required to support form submissions without JavaScript */}
        <input type="hidden" name="form-name" value="contact" />
        <p hidden>
          <label>
            Don’t fill this out: <input name="bot-field" ref={register} />
          </label>
        </p>
        <div>
          <label className="mt-2 mb-6">
            Name*
            <br />
            <input
              type="text"
              name="name"
              ref={register}
              autoFocus
              className="mt-2 block w-full text-gray-700 border rounded py-3 px-4 mb-3 leading-tight  focus:border-blue-600 focus:bg-white"
            />
            <p className="text-red-500 text-xs italic">
              {errors.name?.message}
            </p>
          </label>
        </div>
        <div className="mt-6 mb-6">
          <label>
            Email*
            <br />
            <input
              type="email"
              name="email"
              ref={register}
              className="mt-2 block w-full text-gray-700 border rounded py-3 px-4 mb-3 leading-tight  focus:border-blue-600 focus:bg-white"
            />
            <p className="text-red-500 text-xs italic">
              {errors.email?.message}
            </p>
          </label>
        </div>
        <div className="mt-6 mb-6">
          <label>
            Subject*
            <br />
            <input
              type="text"
              name="subject"
              ref={register}
              className="mt-2 block w-full text-gray-700 border rounded py-3 px-4 mb-3 leading-tight  focus:border-blue-600 focus:bg-white"
            />
            <p className="text-red-500 text-xs italic">
              {errors.subject?.message}
            </p>
          </label>
        </div>
        <div className="mt-6 mb-6">
          <label>
            Message*
            <br />
            <textarea
              name="message"
              ref={register}
              rows="8"
              className="mt-2 block w-full text-gray-700 border rounded py-3 px-4 mb-3 leading-tight  focus:border-blue-600 focus:bg-white"
            />
            <p className="text-red-500 text-xs italic">
              {errors.message?.message}
            </p>
          </label>
        </div>
        <div className="mt-6 mb-6">
          <button
            type="submit"
            className="bg-black hover:bg-grey-dark text-white text-lg py-2 px-4 rounded no-underline inline-block"
          >
            Send Message
          </button>
        </div>
      </form>
    </div>
  )
}

export default ContactForm
